import { useEffect, useState, useCallback } from 'react';
import { Route, Routes } from 'react-router-dom';
import { getAuthStatus, type AuthStatus } from './api';
import { Sidebar } from './components/Sidebar';
import { NewTask } from './pages/NewTask';
import { TaskView } from './pages/TaskView';
import { Mobile } from './pages/Mobile';
import { Setup } from './pages/Setup';
import { Login } from './pages/Login';

export default function App() {
  const [status, setStatus] = useState<AuthStatus | null>(null);
  const [error, setError] = useState<string | null>(null);

  const refresh = useCallback(async () => {
    try {
      const s = await getAuthStatus();
      setStatus(s);
      setError(null);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Unable to reach the server');
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  if (error) {
    return (
      <div className="gate">
        <div className="gate-card">
          <div className="gate-brand">
            <span className="brand-mark" />
            <span className="brand-name">Operator</span>
          </div>
          <div className="form-error" style={{ marginTop: 24 }}>{error}</div>
        </div>
      </div>
    );
  }

  if (!status) {
    return (
      <div className="gate">
        <div className="gate-card" style={{ textAlign: 'center', padding: 60 }}>
          <span className="spinner" style={{ color: 'var(--accent)', width: 18, height: 18 }} />
        </div>
      </div>
    );
  }

  if (!status.setup) {
    return <Setup onDone={refresh} />;
  }

  if (!status.authenticated) {
    return <Login onDone={refresh} />;
  }

  return (
    <div className="app">
      <Sidebar username={status.username ?? ''} onLogout={refresh} />
      <main className="main">
        <Routes>
          <Route path="/" element={<NewTask />} />
          <Route path="/tasks/:id" element={<TaskView />} />
          <Route path="/mobile" element={<Mobile />} />
        </Routes>
      </main>
    </div>
  );
}
